import { createBrowserClient } from '@supabase/ssr'
import { supabaseCookieOptions } from '../subdomain'

export function createClient() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  if (!url || !key) {
    const missing = [!url && 'NEXT_PUBLIC_SUPABASE_URL', !key && 'NEXT_PUBLIC_SUPABASE_ANON_KEY']
      .filter(Boolean)
      .join(', ')
    throw new Error(`Missing Supabase env vars: ${missing}`)
  }

  // cookieOptions carries the shared `.innernet.live` domain when configured,
  // so the session cookie is readable on both apex and the dashboard subdomain.
  // `secure` rides the actual protocol — an https-only site was writing
  // non-secure cookies, which are exactly the cookies webviews shed first.
  //
  // detectSessionInUrl is OFF: every landing absorbs its credential explicitly
  // (/auth/land, /reset-password, the server callback). The SDK's URL detection
  // runs on client init and would consume a single-use credential first,
  // making the page's own exchange "fail" on a session that actually exists.
  //
  // ⚠️ flowType is IMPLICIT, and that is a deliberate reliability decision, not
  // a default. PKCE stores a code verifier in this browser's cookies when a
  // flow starts and needs it back when the code returns — so the whole sign-in
  // hinges on the round trip ending in the same cookie jar it began in. Inside
  // an in-app browser (X, Instagram, Gmail…) and for email links (opened in
  // whatever browser the mail app owns), that assumption is precisely what
  // breaks: John hit "PKCE code verifier not found" completing Google OAuth
  // inside X, on a flow Google itself had allowed. Implicit returns the tokens
  // in the URL fragment of the landing itself — nothing has to survive the
  // trip, so the flow completes wherever it lands: any webview, any browser,
  // any device. /auth/land absorbs the hash explicitly. The fragment never
  // reaches a server log (fragments aren't sent to servers), and /auth/land
  // scrubs it from the address bar before the SDK initialises.
  return createBrowserClient(url, key, {
    cookieOptions: {
      ...supabaseCookieOptions(),
      ...(typeof window !== 'undefined' && window.location.protocol === 'https:' ? { secure: true } : {}),
    },
    auth: { detectSessionInUrl: false, flowType: 'implicit' },
  })
}
